//
export default {

  /**
   * Returns a list representation of the object.
   * @return {Array}  List representation of the object.
   */
  toList() {
    return [
      { 
        text: '#', 
        value: 'id' 
      },
      { 
        text: 'n° documento', 
        value: 'account_number' 
      },
      { 
        text: 'n° serie', 
        value: 'serial_number' 
      },
      { 
        text: 'banco', 
        value: 'g_bank_bank' 
      },
      { 
        text: 'monto', 
        value: 'amount', 
        align: 'right',
        format: 'currency' 
      },
      { 
        text: 'emisión',
        align: 'right',
        value: 'emission_date',
      },
      {
        text: 'cobro',
        align: 'right',
        value: 'charge_date',
      },
      {
        text: 'Estado',
        value: 'sl_check_status_status',
        align: 'center',
        component: {
          type: 'chip-label',
          props: {
            //disabled: true,
            label: true,
            small: true,
            palette: {
              cobrado: 'success lighten-3',
              pendiente: 'accent lighten-3',
            },
          },
        }
      }
    ]
  },
}



